const Lang = require('lang');

module.exports = {
  // responsive: true,
  paging: false,
  info: false,
  order: [],
  language: {
    'sEmptyTable': Lang.get('js/src/helpers/dataTablesConfig.no_records_found'),
    'sInfo': Lang.get('js/src/helpers/dataTablesConfig.showing_start_end_total'),
    'sInfoEmpty': Lang.get('js/src/helpers/dataTablesConfig.showing_0_0_0_records'),
    'sInfoFiltered': Lang.get('js/src/helpers/dataTablesConfig.filtering_max_records'),
    'sInfoPostFix': '',
    'sInfoThousands': '.',
    'sLengthMenu': Lang.get('js/src/helpers/dataTablesConfig.menu_results_per'),
    'sLoadingRecords': Lang.get('js/src/helpers/dataTablesConfig.loading'),
    'sProcessing': Lang.get('js/src/helpers/dataTablesConfig.processing'),
    'sZeroRecords': Lang.get('js/src/helpers/dataTablesConfig.no_records_found'),
    'sSearch': Lang.get('js/src/helpers/dataTablesConfig.search'),
    'oPaginate': {
      'sNext': Lang.get('js/src/helpers/dataTablesConfig.next'),
      'sPrevious': Lang.get('js/src/helpers/dataTablesConfig.previous'),
      'sFirst': Lang.get('js/src/helpers/dataTablesConfig.first'),
      'sLast': Lang.get('js/src/helpers/dataTablesConfig.last')
    },
    'oAria': {
      'sSortAscending': Lang.get('js/src/helpers/dataTablesConfig.sort_asc'),
      'sSortDescending': Lang.get('js/src/helpers/dataTablesConfig.sort_dec')
    }
  }
};
